import React, { Component } from 'react'
import Slider from 'react-slick'

import testimonial1 from '../images/testimonial-1.png'
import testimonial2 from '../images/testimonial-2.png'
import testimonial3 from '../images/testimonial-3.png'
import testimonial4 from '../images/testimonial-4.png'
import testimonial5 from '../images/testimonial-5.png'
import testimonial6 from '../images/testimonial-6.png'
import testimonial7 from '../images/testimonial-7.png'

class HomepageSlider extends Component {

  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.state = {
      render: false
    };
  }

  componentDidMount() {
    this.setState({
      render: true
    });
  }

  next() {
    this.slider.slickNext();
  }

  previous() {
    this.slider.slickPrev();
  }

  render() {

    const { render } = this.state;
    const settings = {
      centerMode: true,
      centerPadding: "0px",
      infinite: true,
      slidesToShow: 5,
      arrows: false,
      responsive: [{
        breakpoint: 1000,
        settings: {
          slidesToShow: 3
        }
      }, {
        breakpoint: 750,
        settings: {
          slidesToShow: 1
        }
      }]
    };

    if (render) {
      return (
        <div className="testimonials__slider">
          <div className="slider__button slider__button--prev" onClick={this.previous}></div>
          <Slider {...settings} className="js-testimonials-slider" ref={c => (this.slider = c)}>
            <div className="testimonial">
              <div className="testimonial__content">
                <img src={testimonial1} alt="Testimonial 1" />
                <h3 className="testimonial__name">Fang H. <span className="flag flag-ch"></span></h3>
                <p className="testimonial__quote">我收到了200多英镑的额外退款，Airvat完成了所有的手续！ ⭐️⭐️⭐️⭐️⭐️</p>
              </div>
            </div>
            <div className="testimonial">
              <div className="testimonial__content">
                <img src={testimonial2} alt="Testimonial 2" />
                <h3 className="testimonial__name">Wang W. <span className="flag flag-ch"></span></h3>
                <p className="testimonial__quote">最后，我完全没有手动填写各种冗长的商店表单就在手机上获得了退税。这服务太棒了！</p>
              </div>
            </div>
            <div className="testimonial">
              <div className="testimonial__content">
                <img src={testimonial3} alt="Testimonial 3" />
                <h3 className="testimonial__name">Fernanda F. <span className="flag flag-br"></span></h3>
                <p className="testimonial__quote">超棒的服务 - 我发现这个App非常简单易用。</p>
              </div>
            </div>
            <div className="testimonial">
              <div className="testimonial__content">
                <img src={testimonial4} alt="Testimonial 4" />
                <h3 className="testimonial__name">Fatima A. <span className="flag flag-uae"></span></h3>
                <p className="testimonial__quote">又快又高效。通过手机就能管理所有免税购物，这真是太好了！</p>
              </div>
            </div>
            <div className="testimonial">
              <div className="testimonial__content">
                <img src={testimonial5} alt="Testimonial 5" />
                <h3 className="testimonial__name">Olivia S. <span className="flag flag-us"></span></h3>
                <p className="testimonial__quote">每家商店都可以！我再也不会回头了 - 这款App让退税变得如此简单。</p>
              </div>
            </div>
            <div className="testimonial">
              <div className="testimonial__content">
                <img src={testimonial6} alt="Testimonial 6" />
                <h3 className="testimonial__name">Grace Y. <span className="flag flag-can"></span></h3>
                <p className="testimonial__quote">这款App改变了免税购物体验。所有事项都在我手机上归于一处。</p>
              </div>
            </div>
            <div className="testimonial">
              <div className="testimonial__content">
                <img src={testimonial7} alt="Testimonial 7" />
                <h3 className="testimonial__name">Yulia B. <span className="flag flag-rus"></span></h3>
                <p className="testimonial__quote">这太棒了！使用简单，所有商店都能用！</p>
              </div>
            </div>
          </Slider>
          <div className="slider__button slider__button--next" onClick={this.next}></div>
        </div>
      );
    }
    return null;
  }
}

export default HomepageSlider